import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';

export default function Summary({ talentAssessment }) {
  return (
    <Row>
      <Col md={6}>
        <h4 className="mb-4">Productivity</h4>

        {talentAssessment.attributes.productivity_summary.map((record) => (
          <IconWithText
            key={record.title}
            iconClassName={record.icon}
            wrapperClassName="mb-4"
          >
            <>
              <h6 className="mb-1">{record.title}</h6>

              <small className="text-gray-700 fw-light">
                {record.label}
              </small>
            </>
          </IconWithText>
        ))}
      </Col>

      <Col md={6}>
        <h4 className="mb-4">Wellbeing</h4>

        {talentAssessment.attributes.wellbeing_summary.map((record) => (
          <IconWithText
            key={record.title}
            iconClassName={record.icon}
            wrapperClassName="mb-4"
          >
            <>
              <h6 className="mb-1">{record.title}</h6>

              <small className="text-gray-700 fw-light">
                {record.label}
              </small>
            </>
          </IconWithText>
        ))}
      </Col>
    </Row>
  );
}

Summary.propTypes = {
  talentAssessment: PropTypes.object.isRequired,
};
